import {Platform} from '@angular/cdk/platform';
import {Directive, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {fromEvent} from 'rxjs';
import {take} from 'rxjs/operators';

@Directive({selector: 'input[appIosAutoFillFix]'})
export class IosAutoFillFixDirective implements OnInit, OnDestroy {
    private intervalId;

    constructor(private elementRef: ElementRef, private platform: Platform) {
    }

    ngOnInit(): void {
        if (this.isDisabled()) {
            return;
        }

        fromEvent(this.elementRef.nativeElement, 'input')
            .pipe(take(1))
            .subscribe(e => this.stopTimer());

        this.startTimer();
    }

    private isDisabled() {
        return !this.platform.IOS || !this.platform.isBrowser;
    }

    private startTimer() {
        const element = this.elementRef.nativeElement;
        const oldValue = element.value;
        let shouldRun = true;

        console.log('start ios auto-fill fix timer', element);

        this.intervalId = setInterval(function () {
            if (!shouldRun) {
                return;
            }
            const elementValue = element.value;
            if (elementValue !== oldValue) {
                element.dispatchEvent(new Event('input'));
                element.blur();
                shouldRun = false;
            }
        }, 300);
    }

    private stopTimer() {
        console.log('stop ios auto-fill fix timer', this.elementRef.nativeElement);
        clearInterval(this.intervalId);
    }

    ngOnDestroy(): void {
        if (this.isDisabled()) {
            return;
        }

        this.stopTimer();
    }
}
